<template>
    <v-select :label="label" :value="value" @input="onInput" :items="options" no-data-text="无权益分组" />
</template>


<script>
import _ from 'lodash'
import { equityStore } from '@/store/equity';

export default {
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        label: {
            type: String,
            default: '权益分组',
        },
        value: {
            type: String,
            required: false,
        },
        pattern: {
            type: Number,
            required: false,
        },
        allowVirtual: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        options() {
            let allowVirtual = this.allowVirtual
            let result = []
            for (let item of equityStore.groupList) {
                let disabled = false
                if (item.is_virtual && !allowVirtual) {
                    disabled = true
                }
                if (!_.isNil(this.pattern) && !_.isNil(item.pattern) && this.pattern !== item.pattern) {
                    disabled = true
                }
                result.push({
                    text: item.name,
                    value: item.id,
                    disabled: disabled,
                })
            }
            return result
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input', value)
        }
    }
}
</script>


<style lang="less" scoped>
@import '~@/styles/common';
</style>